// Duration unit labels for mentoring and split windows. See ClickUp 868jxkz4p §3.
// Every map below is built from the caller's `t` so the labels follow the active
// language — the keys carry the `mentoringPrograms:` prefix so any namespace-bound
// `t` (including the community one used by MentoringBar) resolves them.
export const getDurationUnits = (t) => [
  { id: "days", label: t("mentoringPrograms:durationUnits.days") },
  { id: "weeks", label: t("mentoringPrograms:durationUnits.weeks") },
  { id: "months", label: t("mentoringPrograms:durationUnits.months") },
];

export const getDurationUnitLabel = (t) =>
  getDurationUnits(t).reduce(
    (acc, unit) => ({ ...acc, [unit.id]: unit.label }),
    {}
  );

// Ready-to-use options for Input.Select in the program editor (§6.2).
export const getDurationUnitOptions = (t) =>
  getDurationUnits(t).map((unit) => ({
    label: unit.label,
    value: unit.id,
  }));
